import styled from 'styled-components';
import { colors } from 'nicollet-tokens';

const LinkContainer = styled.span`
  color: ${colors.palette.gray.darkest};
`;

export { LinkContainer };
